import { render } from "./MapGame.vue?vue&type=template&id=803de856"
import script from "./MapGame.vue?vue&type=script&lang=js"
export * from "./MapGame.vue?vue&type=script&lang=js"

import "./MapGame.vue?vue&type=style&index=0&id=803de856&lang=scss"

import exportComponent from "/var/www/vhosts/gilcode.com/kwordz.gilcode.com/packages/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__